/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';

/**
 * CategoryPathStateShareInput Input Action
 */

export class InputFieldValidation implements IActionInput {
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `inputFieldValidation`;
    public getCacheObjectType = () => 'inputFieldValidation';
    public dataCacheType = (): CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface InputFieldValidationState {
    areAllFieldsValid: boolean | undefined;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new InputFieldValidation();
};
/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function sampleStateAction(input: InputFieldValidation, ctx: IActionContext): Promise<InputFieldValidationState> {
    return { areAllFieldsValid: undefined };
}

/**
 * SampleState - create action
 */
export default createObservableDataAction<InputFieldValidationState>({
    action: <IAction<InputFieldValidationState>>sampleStateAction,
    input: createInput
});
